module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_012.png
// module id = 2328
// module chunks = 5